import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScorecardComponent } from './scorecard.component';
import { OverallScoreComponent } from './overall-score/overall-score.component';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';

import { SectionGradeComponent } from './section-grade/section-grade.component';
import { ScorecardService } from './scorecard.service';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActionsComponent } from './actions/actions.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotReadyComponent } from './empty-state/not-ready.component';
import { NotSupportedComponent } from './empty-state/not-supported.component';

import { ActionRefreshComponent } from './action-refresh/action-refresh.component';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { GradeComponent } from '../core/grade/grade.component';
import { LexiconModule } from '@galaxy/lexicon';
import English from '../assets/i18n/en_devel.json';

const MaterialModules = [
  MatCardModule,
  MatDividerModule,
  MatIconModule,
  MatButtonModule,
  MatListModule,
  MatProgressSpinnerModule,
];

const SnapshotModules = [GradeComponent];

@NgModule({
  imports: [
    CommonModule,
    MaterialModules,
    GalaxyEmptyStateModule,
    TranslateModule,
    ClipboardModule,
    GalaxyAlertModule,
    ProductAnalyticsModule,
    SnapshotModules,
    LexiconModule.forChild({
      componentName: 'common/snapshot',
      baseTranslation: English,
    }),
    ScorecardComponent,
    OverallScoreComponent,
    SectionGradeComponent,
    ActionsComponent,
    ActionRefreshComponent,
    NotReadyComponent,
    NotSupportedComponent,
  ],
  exports: [ScorecardComponent, OverallScoreComponent, SectionGradeComponent],
  providers: [ScorecardService],
})
export class ScorecardModule {}
